export default __webpack_public_path__ + "static/media/trash_del.8cd49a2d.svg";